import { Button, Collapse, Grid, makeStyles, Theme, Typography, useTheme } from "@material-ui/core";
import { Alert, AlertTitle } from "@material-ui/lab";
import * as Sentry from "@sentry/react";
import { useState } from "react";
import { Link } from "react-router-dom";
const useStyles = makeStyles({
  alertMessage: {
    width: '100%'
  },
  alertRoot: {
    margin: (theme: Theme) => theme.spacing(2),
    borderRadius: (theme: Theme) => theme.spacing(1)
  }
});
const RouteErrorBoundary: Sentry.FallbackRender = ({
  error
}) => {
  const theme = useTheme();
  const classes = useStyles(theme);
  const [details, setDetails] = useState(false);
  return <>
            <Alert severity="error" classes={{
      message: classes.alertMessage,
      root: classes.alertRoot
    }} data-sentry-element="Alert" data-sentry-source-file="RouteErrorBoundary.tsx">
                <AlertTitle data-sentry-element="AlertTitle" data-sentry-source-file="RouteErrorBoundary.tsx">An error has occurred!</AlertTitle>
                <Typography gutterBottom data-sentry-element="Typography" data-sentry-source-file="RouteErrorBoundary.tsx">
                    Please refresh the page and try again.
                </Typography>
                {(error as any)?.message && <Typography gutterBottom>
                            <strong>Error:</strong> <em>{(error as any).message}</em>
                        </Typography>}
                <Grid container style={{
        display: "flex",
        justifyContent: "flex-end",
        width: "100%"
      }} spacing={2} data-sentry-element="Grid" data-sentry-source-file="RouteErrorBoundary.tsx">
                    <Grid item data-sentry-element="Grid" data-sentry-source-file="RouteErrorBoundary.tsx">
                        {(error as any)?.stack && <>
                                    <Button onClick={() => setDetails(c => !c)}>
                                        More Details
                                    </Button>
                                </>}
                    </Grid>
                    <Grid item data-sentry-element="Grid" data-sentry-source-file="RouteErrorBoundary.tsx">
                        <Button component={Link} to={"/"} variant="contained" data-sentry-element="Button" data-sentry-source-file="RouteErrorBoundary.tsx">
                            Home
                        </Button>
                    </Grid>
                </Grid>
                {(error as any)?.stack && <Collapse in={details}>
                        <pre>
                            {(error as any).stack}
                        </pre>
                    </Collapse>}
            </Alert>
        </>;
};
export default RouteErrorBoundary;